package antd.card

import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.card(handler: RHandler<CardProps>) = child(CardComponent::class, handler)
fun RBuilder.cardGrid(handler: RHandler<CardGridProps>) = child(CardComponent.Grid as ComponentType<CardGridProps>,jsObject{}, handler)
fun RBuilder.cardMeta(handler: RHandler<CardMetaProps>) = child(CardComponent.Meta as ComponentType<CardMetaProps>,jsObject{}, handler)


